module.exports = __webpack_public_path__ + "assets/img/yutari.d1ccd488.svg";